import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59e896a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_forget_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "login_forget_title" }, "メールをご確認ください", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login_forget_description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "login_forget_description_punctuation" }, "ご登録いただいたメールアドレス宛てに"),
  /*#__PURE__*/_createElementVNode("span", { class: "login_forget_description_punctuation" }, "パスワード再設定のご案内をお送りいたしました")
], -1))
const _hoisted_4 = { class: "login_forget_button_login" }
const _hoisted_5 = { class: "login_forget_button_top" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"login_forget_note\" data-v-59e896a9><p class=\"login_forget_note_text\" data-v-59e896a9>メールが届かない場合、原因として以下が考えられます。総合窓口までお問い合わせください。</p><p class=\"login_forget_note_list\" data-v-59e896a9>・過去に当社の転職支援サービスを利用し、現在利用を停止している。</p><p class=\"login_forget_note_list\" data-v-59e896a9>・登録メールアドレスに誤りがある。</p><p class=\"login_forget_mail_title\" data-v-59e896a9>＜総合窓口＞</p><p class=\"login_forget_mail_text\" data-v-59e896a9> メール <a class=\"text_link\" href=\"mailto:webmaster@massmedian.co.jp\" data-v-59e896a9>webmaster@massmedian.co.jp</a></p><p class=\"login_forget_mail_annotation\" data-v-59e896a9> 原則として営業時間の範囲内でご返答してまいります。 <br data-v-59e896a9> 営業時間外にいただいたお問い合わせは翌営業日より順次対応いたします。 <br data-v-59e896a9> 予めご了承ください。 <br data-v-59e896a9> 【営業時間】10:00～18:00（年末年始、土・日曜日、祝日、当社休業日を除く） </p></div>", 1)

import BaseButton from '@/components/BaseButton.vue';
import LinkToTopButton from '@/components/LinkToTopButton.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForgetCompleteView',
  setup(__props) {

const router = useRouter();
const transitionLoginPage = () => {
  router.push({ name: 'a10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: transitionLoginPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("ログイン")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LinkToTopButton)
      ]),
      _hoisted_6
    ])
  ]))
}
}

})